import React from 'react';
import { Flex, Heading, Image, Tooltip } from '@chakra-ui/react';
import Feedback from '../assets/Icon/24px/feedback.svg';

interface HomeHeaderProps {
  title: string;
}

const HomeHeader = ({ title }: HomeHeaderProps) => {
  return (
    <Flex
      bg="white"
      py="12px"
      zIndex={8}
      alignSelf="stretch"
      justifyContent="space-between"
      alignItems="center"
    >
      <Heading
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        lineHeight="tall"
        textAlign="center"
        noOfLines={1}
      >
        {title}
      </Heading>
      <Tooltip
        hasArrow
        label="불편한 점이 있으시면 피드백을 남겨주세요"
        bg="#343B51"
        py="8px"
        px="12px"
        borderRadius="4px"
        defaultIsOpen
      >
        <Image
          src={Feedback}
          onClick={() => {
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSfseRZ7OmQCs8YZHOqBbz_liYeQH6FFaAU3R-tjdFwyFJc3Ug/viewform'
            );
          }}
        />
      </Tooltip>
    </Flex>
  );
};

export default HomeHeader;
